import { IconLoader2 } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '@/contexts/feature-flag-context';

export function RegistrationFlagGuard({ children }: { children: ReactNode }) {
  const enabled = useFeatureFlag('REGISTRATION_ENABLED');
  if (enabled === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <IconLoader2 className="animate-spin size-6 text-muted-foreground" />
      </div>
    );
  if (!enabled) return <Navigate to="/" replace />;
  return <>{children}</>;
}
